export const SIMULATION_INVOICES_HEIGHT = 450;
export const SIMULATION_INVOICES_WIDTH = 1110;
export const SIMULATION_INVOICES_TOP_PADDING = 4;


export const SIMULATION_INVOICES_ITEM_HEIGHT = 52;
export const SIMULATION_INVOICES_ITEM_HEIGHT_PADDING = 4;
export const SIMULATION_INVOICES_ITEM_LEFT_PADDING = 4;
export const SIMULATION_INVOICES_ITEM_WIDTH = '99%';
